import { render, staticRenderFns } from "./MonitorList.vue?vue&type=template&id=5b1d68c4&scoped=true&"
import script from "./MonitorList.vue?vue&type=script&lang=js&"
export * from "./MonitorList.vue?vue&type=script&lang=js&"
import style0 from "./MonitorList.vue?vue&type=style&index=0&id=5b1d68c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1d68c4",
  null
  
)

export default component.exports